
const ValidationHelper = {
    IsAmountNotEmpty:function (amount) {
        return amount !== null && amount !== ''
    },
    IsNaNorNegative:function (amount) {
        if (this.IsAmountNotEmpty(amount)) {
            if (isNaN(parseInt(amount)) || amount <= 0) {
                return true
            }
        } else {
            return false
        }
    },
    IsAPositiveAmountAndNotRequired(amount) {
        if (this.IsNaNorNegative(amount)) {
            return false
        } else {
            return null
        }            
    }
}

export default ValidationHelper


// WEBPACK FOOTER //
// ./src/helpers/validation.js